var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBullet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.712,
    cy: 8.99911,
    r: 8.712,
    fill: "#FECE2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3095 6.2479C12.4069 6.34548 12.4617 6.47775 12.4617 6.61566C12.4617 6.75358 12.4069 6.88585 12.3095 6.98343L7.27879 12.0141C7.18121 12.1116 7.04894 12.1663 6.91103 12.1663C6.77312 12.1663 6.64084 12.1116 6.54326 12.0141L4.28812 9.759C4.19619 9.66034 4.14615 9.52986 4.14852 9.39503C4.1509 9.26021 4.20551 9.13157 4.30087 9.03622C4.39622 8.94087 4.52486 8.88625 4.65968 8.88387C4.7945 8.88149 4.92498 8.93154 5.02364 9.02347L6.91103 10.9109L11.574 6.2479C11.6715 6.15044 11.8038 6.0957 11.9417 6.0957C12.0796 6.0957 12.2119 6.15044 12.3095 6.2479Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.414857
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullet);
export default __webpack_public_path__ + "static/media/bullet.687c3a38d7d9c189315d3994b4c085cb.svg";
export { ForwardRef as ReactComponent };